export default "__VITE_ASSET__vLtuvBRl__"